import { render, staticRenderFns } from "./QuestionFormPMP.vue?vue&type=template&id=7f2445fd&scoped=true"
import script from "./QuestionFormPMP.vue?vue&type=script&lang=js"
export * from "./QuestionFormPMP.vue?vue&type=script&lang=js"
import style0 from "./QuestionFormPMP.vue?vue&type=style&index=0&id=7f2445fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2445fd",
  null
  
)

export default component.exports